const  IconMinus = () => {

    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <line y1="5.5" x2="12" y2="5.5" stroke="#405363"/>
        </svg>
    )

}

export default IconMinus;
